import React from "react";
import Cards from "./Cards";
import { useSelector } from "react-redux";
import { selectBalance } from "../features/balance/balanceSlice";
import { selectUpcomingPayment } from "../features/upcomingPayment/upcomingPaymentSlice";
import { selectSavingCard } from "../features/savingCard/savingCardSlice";

const MainbarCards = () => {
  const account = useSelector(selectBalance);
  const payment = useSelector(selectUpcomingPayment);
  const savingCard = useSelector(selectSavingCard);
  // console.log(payment);
  // console.log(account);
  // console.log(savingCard);
  return (
    <div className="ml-5 flex flex-row mb-5">
      <Cards
        title="Available Balance"
        subheading={`**** **** ${account?.accountNo}`}
        number={account?.balancy}
        button="View Statement"
      />
      <Cards
        title="Upcoming Payments"
        subheading="AT & T Family Package Plan"
        sidesubheading={`Last Date to Pay Bill ${payment?.expireDate}`}
        number="250"
        button="Pay Now"
        isWhite="true"
      />
      <Cards
        title="Savings"
        subheading=""
        sidesubheading={`${savingCard?.goalAchived}% of goal Acheived`}
        bottomLeftSubheading={`$${savingCard?.savingBalance} of $${savingCard?.targetBalance} saved`}
        number=""
        button="Details"
        isWhite="true"
        containsPieChart="true"
      />
    </div>
  );
};

export default MainbarCards;
